import React from 'react';
import { User } from 'lucide-react';
import { PROGRAMS, AGE_GROUPS } from './constants';

const StepPlayerInfo = ({ formData, onChange }) => (
  <div className="form-step">
    <h3><User size={20} /> Player Information</h3>

    <div className="form-row">
      <div className="form-group">
        <label>First Name *</label>
        <input type="text" name="player_first_name" value={formData.player_first_name} onChange={onChange} placeholder="Player's first name" />
      </div>
      <div className="form-group">
        <label>Last Name *</label>
        <input type="text" name="player_last_name" value={formData.player_last_name} onChange={onChange} placeholder="Player's last name" />
      </div>
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>Date of Birth *</label>
        <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={onChange} />
      </div>
      <div className="form-group">
        <label>Age</label>
        <input type="number" name="age" value={formData.age} readOnly placeholder="Auto-calculated" />
      </div>
      <div className="form-group">
        <label>Gender *</label>
        <select name="gender" value={formData.gender} onChange={onChange}>
          <option value="">Select...</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>
    </div>

    <div className="form-row">
      <div className="form-group">
        <label>Program *</label>
        <select name="program" value={formData.program} onChange={onChange}>
          <option value="">Select Program...</option>
          {PROGRAMS.map((p) => (
            <option key={p.value} value={p.value}>{p.label} ({p.ages})</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Age Group/Team *</label>
        <select
          name="team_age_group"
          value={formData.team_age_group}
          onChange={onChange}
          disabled={!formData.program}
        >
          <option value="">Select Age Group...</option>
          {formData.program && AGE_GROUPS[formData.program]?.map((ag) => (
            <option key={ag} value={ag}>{ag}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
);

export default StepPlayerInfo;
